/**
 * @file: anchorKeys.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import {
  ExtendedPropertyValidationErrorInfo,
  OrderForm,
} from '@euler/app/flows/order/types';
import { FormValidationErrors } from '@euler/lib/form/controller';

/**
 * a form row that can be focused when its value fails validation. most rows
 * own exactly one form field, except the extended property rows, which all
 * share the single `extendedProperties` field.
 */
export type FieldErrorAnchorKey =
  | keyof OrderForm
  | `extendedProperties:${string}`;

export const extendedPropertyAnchorKey = (
  propertyId: string,
): FieldErrorAnchorKey => `extendedProperties:${propertyId}`;

/** the rows to focus for the errors a failed validation produced */
export function fieldErrorAnchorKeys(
  errors: FormValidationErrors<OrderForm>,
): FieldErrorAnchorKey[] {
  return Object.entries(errors).flatMap(([prop, error]) => {
    if (prop !== 'extendedProperties') {
      return [prop as FieldErrorAnchorKey];
    }
    return error instanceof ExtendedPropertyValidationErrorInfo
      ? Object.keys(error.errors).map(extendedPropertyAnchorKey)
      : [];
  });
}
